import axios from 'axios';
import Const from './consts';

export default class BasicService {
  constructor() {
    axios.defaults.headers.common['Authorization'] = Const.authorization;
  }
}


// WEBPACK FOOTER //
// ./src/utils/basic.service.js